import {
    FC,
    ReactElement,
    useMemo,
    useState,
} from 'react';

import { useDebounce } from 'react-use';

import { debounceDelay } from '../../../constants';
import { OccupationFilters } from '../../../containers';
import { transformOccupationToSearchableOption } from '../../../models/@competentNL/Occupations/OccupationsTransformers';
import { fetchCompetentNLOccupations } from '../../../redux/competentNL/competentNLActions';
import { setActiveFilterValues } from '../../../redux/occupationOverview/occupationOverview';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';
import { SearchableOption } from '../../../types';

interface ConnectedOccupationFiltersProps {
    className?: string;
}

const ConnectedOccupationFilters: FC<ConnectedOccupationFiltersProps> = ({
    className = '',
}): ReactElement => {
    const dispatch = useTypedDispatch();

    const skills = useTypedSelector(state => state.skillsPassportReducer.careerSkills);

    const isLoading = useTypedSelector(state => state.occupationOverviewReducer.isLoading);
    const activeFilterValues = useTypedSelector(state => state.occupationOverviewReducer.activeFilterValues);

    const occupationsIsLoading = useTypedSelector(state => state.competentNLReducer.occupationsIsLoading);
    const occupations = useTypedSelector(state => state.competentNLReducer.occupations);

    const [searchQuery, setSearchQuery] = useState<string>('');

    const occupationSuggestions = useMemo((): SearchableOption[] => (
        occupations.map(transformOccupationToSearchableOption)
    ), [occupations]);

    useDebounce((): void => {
        if (searchQuery.length > 2) {
            dispatch(fetchCompetentNLOccupations(searchQuery));
        }
    }, debounceDelay, [searchQuery]);

    const handleSearchSubmit = (value: string): void => {
        const newFilterValues = {
            ...activeFilterValues,
            pageNumber: 1,
            searchQuery: value,
        };

        dispatch(setActiveFilterValues(newFilterValues));
    };

    return (
        <OccupationFilters
            isLoading={isLoading}
            isDisabled={skills.length === 0}
            suggestionsIsLoading={occupationsIsLoading}
            activeFilterValues={activeFilterValues}
            occupationSuggestions={occupationSuggestions}
            onSearchChange={setSearchQuery}
            onSearchSubmit={handleSearchSubmit}
            className={className}
        />
    );
};

export default ConnectedOccupationFilters;
